import React, { useState, useEffect } from 'react';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import { Container, Row, Col, Button, Table, Form, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as Common from './../../Common';
import * as Picklist from './../../Picklist';
import AsyncSelect from 'react-select/async';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from 'jquery';
import Dialog from '../../Dialog';
import DatePicker from 'react-datepicker';

const Tran_sanctions_approval = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [sanctionsApprovalData, setSanctionsApprovalData] = useState([]);
    const [sanctionsLocation, setSanctionsLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);
    const [sanctionsIndividualCorporateName, setSanctionsIndividualCorporateName] = useState("");
    const [sanctionsStatus, setSanctionsStatus] = useState('P');
    const [sanctionsFromDate, setSanctionsFromDate] = useState(new Date());
    const [sanctionsToDate, setSanctionsToDate] = useState(new Date());
    const [scrMode, setScrMode] = useState('');
    const [sanctionsDetails, setSanctionsDetails] = useState([]);
    const [approvedDate, setApprovedDate] = useState(new Date());

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_SANCTIONS_APPROVAL'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChangeLocation = (value) => {
        setSanctionsLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
    }

    const handleSanctionsList = () => {
        $(".loader").show();
        const obj = {
            location: locationCode,
            status: sanctionsStatus,
            name: sanctionsIndividualCorporateName,
        }
        Common.callApi(Common.apiSanctionsApproval, [sid, 'getSanctionsList', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            setSanctionsApprovalData(resp);
        });
    }

    const handleBadgeLocation = () => {
        setSanctionsLocation(null);
    }

    const viewSanctionsDetails = (lineNo) => {
        setScrMode('V');
        $(".loader").show();
        const obj = {
            lineNo: lineNo,
        }
        Common.callApi(Common.apiSanctionsApproval, [sid, 'viewSanctionDetails', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            console.log("Details data is :", resp);
            setSanctionsDetails(resp);
        });
        $(".loader").hide();
    }

    const handleApprovedSanctionsData = (lineNo) => {
        $(".loader").show();
        if (!approvedDate) {
            $(".loader").hide();
            setMsgText("Please pick Approval Date.");
            setMsgBox(true);
        } else {
            const obj = {
                location: locationCode,
                status: sanctionsStatus,
                name: sanctionsIndividualCorporateName,
                lineNo: lineNo,
                approvedDate: Common.dateYMD(approvedDate),
            }
            Common.callApi(Common.apiSanctionsApproval, [sid, 'approvedSanctionsData', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                setSanctionsApprovalData(resp);
                $(".loader").hide();
                setScrMode('');
                setMsgText('Request Approved successfully');
                setMsgBox(true);
                handleSanctionsList();
            });
        }
    }

    const handleBackButton = () => {
        setScrMode('');
    }

    const handleRejectSanctionsData = (lineNo) => {
        $(".loader").show();
        const obj = {
            lineNo: lineNo,
        }
        Common.callApi(Common.apiSanctionsApproval, [sid, 'rejectrequest', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            setScrMode('');
            setMsgText('Request Rejected successfully');
            setMsgBox(true);
            handleSanctionsList();
        });
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Sanctions Approval</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {
                    scrMode === "" ?
                        <>

                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="mx-2" ><Badge bg="secondary" className="handCursor" onClick={() => handleBadgeLocation()}>Reset</Badge></span>
                                        </Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={sanctionsLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeLocation}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className="col-md-3 col-6">
                                    <Form.Group>
                                        <Form.Label>Individual/Corporate Name</Form.Label>
                                        <Form.Control type="text" placeholder="Individual/Corporate Name" maxLength={100}
                                            value={sanctionsIndividualCorporateName}
                                            onChange={(e) => Common.validateAlpValue(e.target.value, setSanctionsIndividualCorporateName)}
                                            autoComplete="off"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Status<span className="text-danger">*</span></Form.Label>
                                        <Form.Select value={sanctionsStatus} onChange={e => setSanctionsStatus(e.target.value)}
                                            required>
                                            <option value="P">Pending</option>
                                            <option value="A">Approved</option>
                                            <option value="R">Reject</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            {
                                sanctionsStatus === 'A' &&
                                <>
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={sanctionsFromDate}
                                                    onChange={(date) => setSanctionsFromDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={sanctionsToDate}
                                                    onChange={(date) => setSanctionsToDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </>
                            }
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleSanctionsList}>List</Button>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                            {
                                sanctionsApprovalData.length > 0 ?
                                    <>
                                        <Row>
                                            <Col>
                                                <Table responsive striped bordered hover>
                                                    <thead>
                                                        <tr>
                                                            {userRight.edit === "1" ? <th></th> : null}
                                                            <th>Status</th>
                                                            <th>Request</th>
                                                            <th>Party</th>
                                                            <th>Individual</th>
                                                            <th>Branch</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {sanctionsApprovalData.map((res) =>
                                                            <tr key={res.tsa_line_no}>
                                                                {userRight.query === "1" ?
                                                                    <td className="textCenter" >
                                                                        <span className="handCursor" onClick={() => viewSanctionsDetails(res.tsa_line_no)}>
                                                                            <div className="colorThemeBlue"><FontAwesomeIcon icon={faEye} /></div>
                                                                        </span>
                                                                    </td>
                                                                    : null
                                                                }
                                                                <td>{res.tsa_status === 'P' ? "Pending" : res.tsa_status === 'A' ? "Approved" : "Reject"}</td>
                                                                <td>{res.tsa_timestamp}</td>
                                                                <td>{res.tsa_ledger}</td>
                                                                <td>{res.tsa_individual}</td>
                                                                <td>{res.tsa_branch}</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    </> : null
                            }
                        </> :
                        <>
                            <Row>
                                <Col>
                                    <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleBackButton}>Back</Button>&nbsp;
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <h5>Sanctions Details</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h6>Sanction : <b>{sanctionsDetails[0]?.tsa_master}</b></h6>
                                </Col>
                                <Col>
                                    <h6>Data Id : <b>{sanctionsDetails[0]?.tsa_data_id}</b></h6>
                                </Col>
                            </Row>
                            {/* <Row>
                                <Col>
                                    <h6>Name : <b>{sanctionsDetails[0]?.msh_name}</b></h6>
                                </Col>
                                <Col>
                                    <h6>Date of Birth : <b>{sanctionsDetails[0]?.msh_date_of_birth_year}</b></h6>
                                </Col>
                            </Row> */}
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <h5>Onboarding Request</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label> Status : {sanctionsDetails[0]?.tsa_status === 'P' ? 'Pending' : sanctionsDetails[0]?.tsa_status === 'A' ? 'Approved' : 'Reject'}</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                            {
                                (sanctionsDetails.length > 0 && sanctionsDetails[0].tsa_group * 1 > 0) &&
                                <>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label> Corporate : {sanctionsDetails[0]?.tsa_ledger}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label> Address : {sanctionsDetails[0]?.mvli_address}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </>
                            }
                            {
                                sanctionsDetails.length > 0 && sanctionsDetails[0].tsa_individual_id * 1 > 0 &&
                                <>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label> Individual : {sanctionsDetails[0]?.tsa_individual}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label> Address : {sanctionsDetails[0]?.bd_address}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label> Date of Birth : {sanctionsDetails[0]?.bd_birth_date}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </>
                            }
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label> Branch : {sanctionsDetails[0]?.tsa_branch}</Form.Label>
                                    </Form.Group>
                                </Col>

                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label> User : {sanctionsDetails[0]?.um_user_name}</Form.Label>
                                    </Form.Group>
                                </Col>

                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Created Date : {sanctionsDetails[0]?.tsa_timestamp}</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label> Approved Date : {sanctionsDetails[0]?.tsa_approved_timestamp}</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Approved Till Date : {sanctionsDetails[0]?.tsa_approved_till_date}</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Date<span className="colorThemeRed">*</span></Form.Label>
                                        <DatePicker className="form-control"
                                            selected={approvedDate}
                                            onChange={(date) => setApprovedDate(date)}
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            dropdownMode="select"
                                            peekNextMonth
                                            customInput={
                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                            }
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        sanctionsDetails[0]?.tsa_status !== 'A' &&
                                        <>
                                            <Button variant='outline-success' size='sm' className='buttonStyle' onClick={() => handleApprovedSanctionsData(sanctionsDetails[0].tsa_line_no)}>Approved</Button>&nbsp;
                                        </>
                                    }
                                    {
                                        sanctionsDetails[0]?.tsa_status !== 'R' &&
                                        <>
                                            <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => handleRejectSanctionsData(sanctionsDetails[0].tsa_line_no)}>Reject</Button>
                                        </>
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleBackButton}>Back</Button>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                        </>
                }
            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    )
}

export default Tran_sanctions_approval
